/**
 * Note
 *
 * - After adding a new route, update admin/store/permission.js for route access
 */

const $settings = prebook_admin.settings || {};

export default [
  {
    path: "/",
    redirect: { name: "dashboard" },
    component: () => import("@views/layout/Main.vue"),
    meta: { topBarActions: true },
    children: [
      {
        path: "/dashboard",
        name: "dashboard",
        meta: { title: "Dashboard" },
        component: () => import("@views/dashboard/Index.vue"),
      },
      {
        path: "/calendar",
        name: "calendar",
        meta: { title: "Calendar" },
        component: () => import("@views/calendar/Index.vue"),
      },
      {
        path: "/appointment",
        children: [
          {
            path: "",
            name: "appointment.list",
            meta: { title: `${$settings.labels.appointment?.plural}` },
            component: () => import("@views/appointment/List.vue"),
          },
          {
            path: "add",
            name: "appointment.add",
            meta: { title: `${$settings.labels.appointment?.singular}` },
            component: () => import("@views/appointment/Edit.vue"),
          },
          {
            path: ":appointmentId/edit",
            name: "appointment.edit",
            meta: { title: `${$settings.labels.appointment?.singular}` },
            component: () => import("@views/appointment/Edit.vue"),
          },
        ],
      },
      {
        path: "/service",
        children: [
          {
            path: "",
            name: "service.list",
            meta: { title: `${$settings.labels.service?.plural}` },
            component: () => import("@views/service/List.vue"),
          },
          {
            path: "add",
            name: "service.add",
            meta: { title: `Add ${$settings.labels.service?.singular}` },
            component: () => import("@views/service/Edit.vue"),
          },
          {
            path: ":serviceId/edit",
            name: "service.edit",
            meta: { title: `Edit ${$settings.labels.service?.singular}` },
            component: () => import("@views/service/Edit.vue"),
          },
        ],
      },
      {
        path: "/staff",
        redirect: { name: "staff.list" },
        children: [
          {
            path: "",
            name: "staff.list",
            meta: { title: `${$settings.labels.staff?.plural}` },
            component: () => import("@views/staff/List.vue"),
          },
          {
            path: "invite",
            name: "staff.invite",
            meta: { title: `${$settings.labels.staff?.singular}` },
            component: () => import("@views/staff/Invite.vue"),
          },
          {
            path: "add",
            name: "staff.add",
            meta: { title: `Add ${$settings.labels.staff?.singular}` },
            component: () => import("@views/staff/Edit.vue"),
          },
          {
            path: ":staffId/edit",
            name: "staff.edit",
            meta: { title: `Update ${$settings.labels.staff?.singular}` },
            component: () => import("@views/staff/Edit.vue"),
          },
          {
            path: ":staffId/view",
            name: "staff.view",
            meta: { title: `${$settings.labels.staff?.singular}` },
            component: () => import("@views/staff/View.vue"),
          },
        ],
      },
      {
        path: "/settings",
        redirect: { name: "settings" },
        meta: { topBarActions: false },
        children: [
          {
            path: "",
            name: "settings",
            meta: { title: "Settings" },
            component: () => import("@views/settings/Index.vue"),
          },
          {
            path: "general",
            name: "settings.general",
            meta: { title: "General" },
            component: () => import("@views/settings/General.vue"),
          },
          {
            path: "business",
            name: "settings.business",
            meta: { title: "Business Profile" },
            component: () => import("@views/settings/BusinessProfile.vue"),
          },
          {
            path: "provider",
            name: "settings.provider",
            meta: { title: `${$settings.labels.service?.singular} Provider` },
            component: () => import("@views/settings/ServiceProvider.vue"),
          },
          {
            path: "business-hours",
            name: "settings.business_hours",
            meta: { title: "Business Hours" },
            component: () => import("@views/settings/BusinessHours.vue"),
          },
          {
            path: "payments",
            name: "settings.payments",
            meta: { title: `${$settings.labels.payment?.plural}` },
            component: () => import("@views/settings/Payments.vue"),
          },
          {
            path: "labels",
            name: "settings.labels",
            meta: { title: "Labels" },
            component: () => import("@views/settings/Labels.vue"),
          },
          {
            path: "addons",
            name: "settings.addons",
            meta: { title: "Addons" },
            component: () => import("@views/settings/Addon.vue"),
          },
          {
            path: "integrations",
            name: "settings.integrations",
            meta: { title: "Integrations" },
            component: () => import("@views/settings/Integrations.vue"),
          },
        ],
      },
      {
        path: "/customer",
        children: [
          {
            path: "",
            name: "customer.list",
            meta: { title: `${$settings.labels.customer?.plural}` },
            component: () => import("@views/customer/List.vue"),
          },
          {
            path: "add",
            name: "customer.add",
            meta: { title: `Add ${$settings.labels.customer?.singular}` },
            component: () => import("@views/customer/Edit.vue"),
          },
          {
            path: ":customerId/edit",
            name: "customer.edit",
            meta: { title: `Edit ${$settings.labels.customer?.singular}` },
            component: () => import("@views/customer/Edit.vue"),
          },
          {
            path: ":customerId/view",
            name: "customer.view",
            meta: { title: `${$settings.labels.customer?.singular}` },
            component: () => import("@views/customer/View.vue"),
          },
        ],
      },
      {
        path: "/transaction",
        children: [
          {
            path: "",
            name: "transaction.list",
            meta: { title: `${$settings.labels.payment?.plural}` },
            component: () => import("@views/transaction/List.vue"),
          },
          {
            path: ":transactionId/edit",
            name: "transaction.edit",
            meta: { title: `${$settings.labels.payment?.singular}` },
            component: () => import("@views/transaction/Edit.vue"),
          },
        ],
      },
      {
        path: "/notification",
        children: [
          {
            path: "",
            name: "notification.list",
            meta: { title: "Notifications" },
            component: () => import("@views/notification/List.vue"),
          },
          {
            path: ":notificationId/edit",
            name: "notification.edit",
            meta: { title: "Edit Notification" },
            component: () => import("@views/notification/Edit.vue"),
          },
        ],
      },
      {
        path: "/activity",
        children: [
          {
            path: "",
            name: "activity.list",
            meta: { title: "Activity" },
            component: () => import("@views/activity/List.vue"),
          },
        ],
      },
      {
        path: "/logout",
        name: "logout",
        meta: { title: "Logout" },
        component: () => import("@views/Blank.vue"),
      },
      {
        path: "/customizer",
        name: "customizer",
        meta: { title: "Customizer" },
        component: () => import("@views/customizer/Index.vue"),
        // redirect: { name: 'customizer.form.service' },
      },
      // {
      // 	path: '/chat/customizer',
      // 	name: 'chat.customizer',
      // 	meta: { title: 'Chat Customizer' },
      // 	redirect: { name: 'chat.customizer.banner' },
      // },
      {
        path: "/onboarding",
        meta: { title: "Add business profile" },
        redirect: { name: "onboarding.business.info" },
        children: [
          {
            path: "business/info",
            name: "onboarding.business.info",
            meta: { title: "Add business profile" },
            component: () =>
              import("@views/onboarding/BusinessInformation.vue"),
          },
          {
            path: "business/address",
            name: "onboarding.business.address",
            meta: { title: "Add business profile" },
            component: () => import("@views/onboarding/BusinessAddress.vue"),
            beforeEnter: (to, from, next) => {
              if (from.name == "onboarding.business.info") {
                next();
              } else {
                next({ name: "onboarding.business.info" });
              }
            },
          },
          {
            path: "business/hours",
            name: "onboarding.business.hours",
            meta: { title: "Set working hours" },
            component: () => import("@views/onboarding/BusinessHours.vue"),
          },
          {
            path: "service/general",
            name: "onboarding.service.general",
            meta: {
              title: `Create your ${$settings.labels.service?.singular}`,
            },
            component: () => import("@views/onboarding/ServiceGeneral.vue"),
          },
          {
            path: "service/staff",
            name: "onboarding.service.staff",
            meta: {
              title: `Assign ${$settings.labels.service?.singular} to ${$settings.labels.staff?.singular}`,
            },
            component: () => import("@views/onboarding/ServiceStaff.vue"),
            beforeEnter: (to, from, next) => {
              if (
                from.name == "onboarding.service.general" ||
                from.name == "onboarding.service.duration"
              ) {
                next();
              } else {
                next({ name: "onboarding.service.general" });
              }
            },
          },
          {
            path: "service/duration",
            name: "onboarding.service.duration",
            meta: { title: "Set Duration & Price" },
            component: () => import("@views/onboarding/ServiceDuration.vue"),
            beforeEnter: (to, from, next) => {
              if (
                from.name == "onboarding.service.staff" ||
                from.name == "onboarding.service.general"
              ) {
                next();
              } else {
                next({ name: "onboarding.service.general" });
              }
            },
          },
          {
            path: "staff/profile",
            name: "onboarding.staff.profile",
            meta: { title: `Add your ${$settings.labels.staff?.singular}` },
            component: () => import("@views/onboarding/StaffProfile.vue"),
          },
        ],
      },
    ],
  },
  {
    path: "/customizer/chat",
    name: "customizer.chat",
    meta: { title: "Booking Chat Widget Customizer" },
    redirect: { name: "customizer.chat.banner" },
    component: () => import("@views/customizer/chat/Layout.vue"),
    children: [
      {
        path: "banner",
        name: "customizer.chat.banner",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Banner.vue"),
      },
      {
        path: "welcome",
        name: "customizer.chat.welcome",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Welcome.vue"),
      },
      {
        path: "overview",
        name: "customizer.chat.overview",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Overview.vue"),
      },
      {
        path: "service",
        name: "customizer.chat.service",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Service.vue"),
      },
      {
        path: "staff",
        name: "customizer.chat.staff",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Staff.vue"),
      },
      {
        path: "date",
        name: "customizer.chat.date",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Date.vue"),
      },
      {
        path: "time",
        name: "customizer.chat.time",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Time.vue"),
      },
      {
        path: "account",
        name: "customizer.chat.account",
        meta: { title: "Booking Chat Widget Customizer" },
        component: () => import("@views/customizer/chat/Account.vue"),
      },
    ],
  },
  {
    path: "/customizer/form",
    name: "customizer.form",
    meta: { title: "Booking Form Customizer" },
    redirect: { name: "customizer.form.service" },
    component: () => import("@views/customizer/form/Layout.vue"),
    children: [
      {
        path: "service",
        name: "customizer.form.service",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Service.vue"),
      },
      {
        path: "staff",
        name: "customizer.form.staff",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Staff.vue"),
      },
      {
        path: "date",
        name: "customizer.form.date",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Date.vue"),
      },
      {
        path: "time",
        name: "customizer.form.time",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Time.vue"),
      },
      // {
      // 	path: 'appointment/type',
      // 	name: 'customizer.form.appointment.type',
      // 	meta: { title: 'Booking Form Customizer' },
      // 	component: () => import('@views/customizer/form/AppointmentType.vue'),
      // },
      {
        path: "account",
        name: "customizer.form.account",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Account.vue"),
      },
      {
        path: "overview",
        name: "customizer.form.overview",
        meta: { title: "Booking Form Customizer" },
        component: () => import("@views/customizer/form/Overview.vue"),
      },
    ],
  },
  {
    path: "/chat/customizer",
    name: "chat.customizer",
    meta: { title: "Booking Widget" },
    redirect: { name: "chat.customizer.top-banner" },
    component: () => import("@views/chatCustomizer/Layout.vue"),
    children: [
      // {
      // 	path: 'widget',
      // 	name: 'chat.customizer.widget',
      // 	component: () => import('@views/chatCustomizer/widget/Main.vue')
      // },
      {
        path: "top-banner",
        name: "chat.customizer.top-banner",
        component: () => import("@views/chatCustomizer/widget/TopBanner.vue"),
      },
      {
        path: "welcome-title",
        name: "chat.customizer.welcome-title",
        component: () =>
          import("@views/chatCustomizer/widget/WelcomeTitle.vue"),
      },
      {
        path: "service",
        name: "chat.customizer.service",
        component: () => import("@views/chatCustomizer/widget/Service.vue"),
      },
      {
        path: "staff",
        name: "chat.customizer.staff",
        component: () => import("@views/chatCustomizer/widget/Staff.vue"),
      },
      {
        path: "date",
        name: "chat.customizer.date",
        component: () => import("@views/chatCustomizer/widget/Date.vue"),
      },
      {
        path: "time",
        name: "chat.customizer.time",
        component: () => import("@views/chatCustomizer/widget/Time.vue"),
      },
      {
        path: "account",
        name: "chat.customizer.account",
        component: () => import("@views/chatCustomizer/widget/Account.vue"),
      },
      {
        path: "overview",
        name: "chat.customizer.overview",
        component: () => import("@views/chatCustomizer/widget/Overview.vue"),
      },
    ],
  },
  // {
  // 	path: '/customizer/widget',
  // 	name: 'customizer.widget',
  // 	redirect: { name: 'customizer.widget.general' },
  // 	component: () => import('@views/customizer/widget/Layout.vue'),
  // 	children: [
  // 		{
  // 			path: 'general',
  // 			name: 'customizer.widget.general',
  // 			component: () => import('@views/customizer/widget/Index.vue')
  // 		}
  // 	]
  // }
  // {
  // 	path: '/agents', component: () => import('@views/agent/Main.vue'), children: [
  // 		{ path: '', name: 'agentDashboard', component: () => import('@views/agent/List.vue') },
  // 		{ path: ':agentId/', name: 'agentProfile', component: () => import('@views/agent/Profile.vue') },
  // 		{ path: ':agentId/update', name: 'agentProfile', component: () => import('@views/agent/Update.vue') },
  // 	]
  // },
];
